/** A fresh browser position for "My current location", or why there isn't one. */
export type LocationResult =
  | { ok: true; lat: number; lng: number; accuracy: number }
  | { ok: false; reason: 'unsupported' | 'denied' | 'unavailable' | 'timeout' };

const REASONS: Record<number, 'denied' | 'unavailable' | 'timeout'> = { 1: 'denied', 2: 'unavailable', 3: 'timeout' };

export function currentLocation(
  geolocation: Geolocation | undefined = typeof navigator !== 'undefined' ? navigator.geolocation : undefined,
  timeoutMs = 10000,
): Promise<LocationResult> {
  if (!geolocation) return Promise.resolve({ ok: false, reason: 'unsupported' });
  return new Promise((resolve) => {
    geolocation.getCurrentPosition(
      (position) => resolve({
        ok: true,
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        accuracy: position.coords.accuracy,
      }),
      (error) => resolve({ ok: false, reason: REASONS[error?.code] ?? 'unavailable' }),
      // A cached fix up to 15 s old is fine, as on iOS; older ones can be far from the walker.
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 15000 },
    );
  });
}
